import React, { useMemo, useState } from 'react';
import { FormControlLabel, Switch, CircularProgress } from "@mui/material";
import { useAccountById, useUpdateAccount } from "queries/accounts";
import { usePromptLabels } from "queries/promptLabels";
import { useAgencyInfo } from "context/agency";

const PromptLabels = ({ formData }) => {
    const [loadingId, setLoadingId] = useState(null); // Track the currently loading toggle
    const [agency] = useAgencyInfo();

    const { data: accountPromptIds, isLoading: isAccountLoading } = useAccountById(formData?.id);
    const selectedIds = accountPromptIds?.data?.promptlabels_ids || [];

    // Two separate hook calls (agency-level + super-admin-level labels),
    // merged client-side - same two requests + api_type==='team' filter the
    // old Promise.all did, without needing a new combined endpoint in
    // queries/promptLabels.js (owned by another fork).
    const { data: agencyLabels = [], isLoading: isAgencyLabelsLoading } = usePromptLabels(
        { agencyId: agency._id, type: "agency" },
        { enabled: !!agency._id },
    );
    const { data: adminLabels = [], isLoading: isAdminLabelsLoading } = usePromptLabels(
        { agencyId: "superYxadminagency_id", type: "super-admin" },
        { enabled: !!agency._id },
    );
    const isLabelsLoading = isAgencyLabelsLoading || isAdminLabelsLoading;
    const promptslabel = useMemo(
        () => [...agencyLabels, ...adminLabels].filter((item) => item.api_type === 'team'),
        [agencyLabels, adminLabels],
    );

    const { mutateAsync: updatePromptIds } = useUpdateAccount(true);

    const AccountUpdate = async (updatedIds) => {
        const payload = {
            promptlabels_ids: updatedIds,
            _id: formData.id,
        };

        const { response } = await updatePromptIds(payload);
        if (response) {
            console.log(`Updated successfully for IDs: ${updatedIds}`);
        }
    };

    const handleToggleChange = async (id) => {
        setLoadingId(id); // Set the current toggle as loading

        const updatedIds = selectedIds.includes(id)
            ? selectedIds.filter(itemId => itemId !== id) // Remove if already selected
            : [...selectedIds, id]; // Add if not selected

        try {
            await AccountUpdate(updatedIds); // Pass the updated state directly
        } finally {
            setLoadingId(null); // Reset loading after request completion
        }
    };

    if (isAccountLoading || isLabelsLoading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
                <CircularProgress size={28} />
            </div>
        );
    }

    return (
        <div>
            {promptslabel.length > 0 && promptslabel.map((item, index) => (
                <div
                    key={index}
                    style={{
                        marginBottom: "10px",
                        borderRadius: '10px',
                        border: "1px solid rgba(229, 229, 229, 1)",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <p className="px-5-dd text-left font-bold" style={{ width: "25%" }}>
                        {item?.name ? item?.name : item?.template?.templatename}
                    </p>
                    <p className="px-5-dd text-left font-bold" style={{ width: "75%", textAlign: "right" }}>
                        {loadingId === item?._id ? (
                            // Show loader for the current loading toggle
                            <CircularProgress size={24} />
                        ) : (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={selectedIds.includes(item?._id)}
                                        onChange={() => handleToggleChange(item?._id)}
                                        disabled={loadingId !== null} // Disable all toggles while loading
                                    />
                                } label=""
                            />
                        )}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default PromptLabels;
